import { Component } from '@angular/core';
import { ChartData, ChartOptions } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {
  barChartData: ChartData<'bar'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Excellent', data: [1000, 1200, 1050, 2000, 500] },
      { label: 'Good', data: [200, 100, 400, 50, 90] },
      { label: 'Not good', data: [500, 400, 350, 450, 650] },
      { label: 'Bad', data: [1200, 1500, 1020, 1600, 900] },
    ],
  };
  barChartOptions:ChartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Chat Feedback',
      },
    },
  };
  // Pie
  pieChartData: ChartData<'bar'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Chat Interactions', data: [1000, 1200, 1050, 2000, 500] }
    ],
  };
  pieChartOptions:ChartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Chat Interactions',
      },
    },
  };
  // Line
  lineChartData: ChartData<'bar'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May'],
    datasets: [
      { label: 'Positive', data: [1000, 1200, 1050, 2000, 500] },
      { label: 'Negative', data: [100, 120, 105, 200, 50] },
    ],
  };
  lineChartOptions:ChartOptions = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: 'Chat Sentiments',
      },
    },
  };
}
